<script setup lang="ts">
import type { BluffReveal } from '../../shared/contracts/bluff'
import { optionLetter } from '../services/bluff'

defineProps<{ reveal: BluffReveal }>()

const kindLabel = { TRUTH: 'The truth', BLUFF: 'Bluff', DECOY: 'House decoy' } as const
</script>

<template>
  <section class="stack">
    <div class="truth-card">
      <span class="text-sm fw-6 upper">The truth</span>
      <strong>{{ reveal.truth }}</strong>
      <p>{{ reveal.explanation }}</p>
      <p class="text-sm muted-text">
        Source:
        <a
          v-if="reveal.sourceUrl"
          class="link"
          :href="reveal.sourceUrl"
          target="_blank"
          rel="noopener noreferrer"
        >{{ reveal.sourceName }}</a>
        <span v-else>{{ reveal.sourceName }}</span>
      </p>
    </div>
    <ul class="option-list">
      <li
        v-for="(option, index) in reveal.options"
        :key="option.id"
        class="reveal-option"
        :class="{ 'is-truth': option.kind === 'TRUTH' }"
      >
        <div class="reveal-option__head">
          <strong><span class="option-letter">{{ optionLetter(index) }}</span>{{ option.text }}</strong>
          <span
            class="tag"
            :class="option.kind === 'TRUTH' ? 'tag--secondary' : option.kind === 'BLUFF' ? 'tag--primary' : 'tag--muted'"
          >{{ kindLabel[option.kind] }}</span>
        </div>
        <p
          v-if="option.authors.length"
          class="text-sm"
        >
          Written by {{ option.authors.join(', ') }}
        </p>
        <p class="text-sm muted-text">
          {{ option.voters.length ? `${option.kind === 'TRUTH' ? 'Found it' : 'Fell for it'}: ${option.voters.join(', ')}` : 'No votes' }}
          <template v-if="option.points">
            · {{ option.points }} points
          </template>
        </p>
      </li>
    </ul>
  </section>
</template>
